//#region
import axios from 'axios';
import { url, endPoint } from '../urls';
//#endregion

export function getDashboardList(params) {
    let _url = url.backendHost + endPoint.dashboards.getDashboardList;
    return axios.get(_url, { params });
}

export function changeStatus(params) {
    let _url = url.backendHost + endPoint.dashboards.changeStatus;
    return axios.put(_url, params);
}

export function getDashboarDetails(params) {
    let _url = url.backendHost + endPoint.dashboards.getDashboarDetails;
    return axios.get(_url, {params});
}

export function addDashboard(params) {
    let _url = url.backendHost + endPoint.dashboards.addDashboard;
    return axios.post(_url, params );
}

export function updateDashboard(params) {
    let _url = url.backendHost + endPoint.dashboards.updateDashboard;
    return axios.put(_url, params );
}

export function publishDashboard(params) {
    let _url = url.backendHost + endPoint.dashboards.publishDashboard;
    return axios.put(_url, params);
}

export function deleteDashboard(params) {
    let _url = url.backendHost + endPoint.dashboards.deleteDashboard;
    return axios.post(_url, params );
}

export function getAllDashboardsWOAuth(params) {
    let _url = url.backendHost + endPoint.dashboards.getAllDashboardsWOAuth;
    return axios.get(_url, { params });
}

export function validateUserDashboard(params) {
    let _url = url.backendHost + endPoint.dashboards.validateUserDashboard;
    return axios.get(_url, {params});
}

export function updateTabDesign(params) {
    console.log(params, '.......');
    let _url = url.backendHost + endPoint.dashboards.updateTabDesign;
    return axios.post(_url, params);
}